/** 与 home LeftMenu useMenuTransitionEnd 一致：动画结束后再等 100ms 触发 resize */
const COPILOT_LAYOUT_RESIZE_DELAY_MS = 100;

let layoutResizeTimer: number | null = null;

/**
 * Copilot 布局变化后延迟触发 window.resize，供页面 ECharts 等现有 listener 自适应。
 * 仅 Copilot 模块使用，不修改 home / LeftMenu 等底层组件。
 */
export function scheduleCopilotLayoutResize(): void {
  if (layoutResizeTimer) {
    window.clearTimeout(layoutResizeTimer);
  }
  layoutResizeTimer = window.setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
    layoutResizeTimer = null;
  }, COPILOT_LAYOUT_RESIZE_DELAY_MS);
}
